import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { Play } from 'lucide-react';

export default function Welcome() {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="bg-white py-12 sm:py-16 md:py-24" id="about">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Left - Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-4 sm:space-y-6"
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
              Welcome to Elite Roofing<br />
              <span className="text-[hsl(var(--primary))]">Your Premier Roofing & Exterior Company</span>
            </h2>
            
            <div className="space-y-3 sm:space-y-4 text-slate-600 text-sm sm:text-base leading-relaxed">
              <p>
                Elite Roofing first opened our doors with a mission to provide exceptional roofing and exterior construction services throughout Central Florida. Since then, we have completed hundreds of successful projects, becoming a trusted name in both residential and commercial roofing restoration.
              </p>
              
              <p>
                We are your one-stop solution for the best commercial & residential roofing and exterior services. Our commitment to quality, professionalism, and customer satisfaction sets us apart from other contractors in the region.
              </p>
              
              <p>
                Our high-quality materials, experienced craftsmanship, and comprehensive warranties will give you confidence in choosing Elite Roofing as your contractor. Our professional team treats every project with care, ensuring the job is done right to standards that exceed industry expectations.
              </p>
              
              <p className="font-semibold text-slate-900">
                All our services begin with a <span className="text-[hsl(var(--accent))]">FREE roof inspection</span>. Give us a call today at <a href="tel:+14077850642" className="text-[hsl(var(--primary))] hover:underline">(407) 785-0642</a> to schedule a free inspection or to ask any questions about our services.
              </p>
            </div>

            <Button 
              onClick={scrollToForm}
              className="h-12 sm:h-14 px-6 sm:px-8 bg-[hsl(var(--accent))] text-white hover:bg-[#a01830] transition-all shadow-lg text-base sm:text-lg font-semibold w-full sm:w-auto"
            >
              Schedule Free Inspection
            </Button>
          </motion.div>

          {/* Right - Image/Video Placeholder */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="relative aspect-video rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
              <img 
                src="https://images.unsplash.com/photo-1668911495278-487418f8f72d?auto=format&fit=crop&w=1200&q=80" 
                alt="Elite Roofing Completed Project" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-center justify-center">
                <div className="text-center text-white">
                  <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/20 backdrop-blur-sm border-4 border-white/30 hover:bg-white/30 transition-all cursor-pointer">
                    <Play className="h-8 w-8 sm:h-10 sm:w-10 fill-white ml-1" />
                  </div>
                  <p className="mt-3 sm:mt-4 text-xs sm:text-sm font-semibold">Watch Our Story</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}